import React from 'react';
import { compose } from '@/utils/story-composer';
import CategoryNavigation from '@/components/layout/blog/category-navigation';
import BlogPostContainer from '@/components/layout/blog/post-container';
import Wave from '../elements/wave';
import { getTranslatableSlug } from '@/utils/translatable-slug';

function BlogCategory({ elementProps, pageContext }) {
	const { categories, posts, category, numPages, currentPage, paginationLink } = pageContext;

	const translatedSlug = getTranslatableSlug(category, category.lang);
	const categoryName = translatedSlug?.name || category.name;

	return (
		<div {...elementProps} className="flex flex-col">
			<div className="bg-tree-poppy">
				<div className="container flex-col py-20 flex items-center justify-center">
					<h1 className="text-5xl text-white pb-8">{categoryName}</h1>
					<h2 className="text-md text-white font-light">{category.content.subtitle}</h2>
				</div>

				<Wave backgroundColor="bg-tree-poppy" />
			</div>
			<div className="container lg:flex">
				<CategoryNavigation categories={categories} />
				<BlogPostContainer
					posts={posts}
					numPages={numPages}
					currentPage={currentPage}
					paginationLink={paginationLink}
				/>
			</div>
		</div>
	);
}

compose('blog-category', BlogCategory);

export default BlogCategory;
